export class EventLocation {
  id: string;
  eventId: string;
  serviceAreaId: string;
  name: string;
  attendance: number;
}
